<template>
  <div>
    <div
      v-if="teams.length"
      class="teams"
    >
      <div
        v-for="team in teams"
        :key="team.id"
        class="teams__item"
      >
        <div class="teams__title">
          {{ name(team) }}
        </div>
        <div
          v-if="team.employees.length"
          class="teams__employees"
        >
          <div
            v-for="employee in team.employees"
            :key="employee.id"
            class="teams__employee"
          >
            <div class="teams__employee-avatar">
              <img
                v-if="employee.photo_url"
                :src="employee.photo_url"
                :alt="employee.name"
              >
              <ProfileImg
                v-else
                class="w-full"
              />
            </div>
            <span class="teams__employee-name">{{ employee.name }}<br>{{ employee.surname }}</span>
            <span class="teams__employee-job">{{ employee.job_position }}</span>
            <span class="teams__employee-phone">{{ employee.phone ? employee.phone : '-' }}</span>
            <a
              v-if="employee.email"
              :href="`mailto:${employee.email}`"
              class="teams__employee-email"
            >
              {{ window.width > 959 ? stringLimit(employee.email, 22) : employee.email }}
            </a>
            <span v-else>-</span>
          </div>
        </div>
        <div
          v-else
          class="teams__no-results"
        >
          {{ $t('team.noResults') }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="teams__no-results"
    >
      {{ $t('team.noResults') }}
    </div>
  </div>
</template>
<script>
import { stringLimit } from '@/utils/stringLimit';
import ProfileImg from '@/assets/img/profile.svg';
import name from '@/mixins/name';

export default {
  name: 'TeamList',
  components: {
    ProfileImg,
  },
  mixins: [name],
  props: {
    teams: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      window: {
        width: 0,
      },
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    stringLimit,
    handleResize() {
      this.window.width = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" scoped>
.teams {
  &__item {
    @apply mb-8 pt-6 pb-2 px-4 rounded-md;
    background: white;
    display: grid;
    grid-template-columns: 1fr;
    @screen lg {
      grid-template-columns: 150px 1fr;
    }
  }
  &__title {
    @apply pb-8 text-primary font-semibold;
    grid-column: 1 / 2;
    @screen sm {
      @apply text-lg;
    }
    @screen lg {
      @apply pb-0;
    }
  }
  &__employees {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @screen sm {
      grid-template-columns: repeat(2, 1fr);
    }
    @screen lg {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  &__employee {
    @apply px-1 pb-6 text-center;
    display: flex;
    flex-direction: column;
    align-items: center;
    word-break: break-word;
    &-name {
      @apply pt-4 pb-2 text-sm font-semibold text-primary;
      @screen sm {
        @apply text-base;
      }
    }
    &-phone,
    &-email {
      @apply text-xs text-gray-700;
    }
    &-job {
      @apply uppercase font-semibold text-xs pb-1;
      @screen sm {
        @apply text-sm;
      }
    }
    &-email {
      &:hover {
        @apply underline;
      }
    }
    &-avatar {
      border-radius: 50%;
      width: 80px;
      height: 80px;
      overflow: hidden;
      img {
        object-fit: cover;
      }
    }
  }
  &__no-results {
    @apply pt-1 text-sm text-center;
  }
}

</style>
